import React, { ReactNodeArray } from 'react';
import { useIntl } from 'react-intl';
import messages from './intl';
import styles from './index.scss';

type Props = {
  header?: string | ReactNodeArray,
  description?: string | ReactNodeArray,
  image?: string,
}

const Loading = (props: Props) => {
  const { header, description, image } = props;
  const intl = useIntl();

  return (
    <div data-qa-ref="webflow-state-loading-page">
      <div className={styles.image}
        data-qa-ref="webflow-state-loading-image"
      >
        <img
          className={styles.image}
          src={image}
          alt={intl.formatMessage(messages.imageAlt)} />
      </div>
      <div
        className={styles.header}
        data-qa-ref="webflow-state-header"
      >
        {header}
      </div>
      <div
        className={styles.description}
        data-qa-ref="webflow-state-description"
      >
        {description}
      </div>
    </div>
  );
};

export default Loading;
